import webcamStartTemplate from './webcam-start.tpl.html';
import { CAMERA_WARMUP_MS } from '../../services/photo-manager-service/photo-manager-service';
import './webcam-start.less';
import { appAlertComponentModule } from '../../../../shared/app/components/app-alert/app-alert';

const findPhotoManagerErrorMessage = (err) => {
  if (err.statusText || err.message) {
    return err.statusText || err.message;
  } else if (err) {
    return err;
  }
  return 'Unknown Photo Manager error';
};

export const webcamStartComponentModule = angular
  .module('Q.components.webcam-start', [appAlertComponentModule])

  .component('webcamStart', {
    bindings: {
      process: '=',
      photoManager: '=',
      onErrorWhilePhotoManagerStarts: '&',
      onPhotoManagerStarted: '&',
    },
    template: webcamStartTemplate,
    controller: 'WebcamStartCtrl',
    controllerAs: '$ctrl',
  })
  .controller(
    'WebcamStartCtrl',
    function WebcamStartCtrl($element, $log, $modal, $timeout, appAlert) {
      const ctrl = this;

      ctrl.showProctoring = () =>
        ctrl.process.assessment.proctoringEnabled() &&
        !ctrl.process.assessmentResult.proctoringDisabled;

      const addProctoringVideo = () => {
        ctrl.photoManager
          .newExternalVideo()
          .then((video) => {
            const container = $element.querySelector('.webcam-feed-container');
            container.empty();
            container.append(video);
          })
          .catch((err) => {
            $log.error(err);
            appAlert.error('Photo Manager: Webcam preview failed');
          });
      };

      ctrl.webcamVisible = false;
      ctrl.toggleWebcamVisibility = () => {
        ctrl.webcamVisible = !ctrl.webcamVisible;

        if (ctrl.webcamVisible) {
          addProctoringVideo();
        }
      };

      const handlePhotoManagerError = () => {
        ctrl.webcamVisible = false;
        ctrl.onErrorWhilePhotoManagerStarts();
      };

      ctrl.startPhotoManager = () => {
        const result = ctrl.process.assessmentResult;

        if (!result) {
          $log.error(
            'process.assessmentResult was undefined starting photoManager',
          );
          appAlert.error('Unable to start webcam; please try again');
          return;
        }

        ctrl.photoManager
          .start({
            assessmentResultId: result.id,
            teamCandidateId: result.teamCandidateId,
          })
          // Start is gated on a stored photo, so capture cannot wait for the candidate to press it.
          .then(() => ctrl.onPhotoManagerStarted())
          .catch(handlePhotoManagerError);
      };
    },
  )
  .controller(
    'WebcamRestartCtrl',
    function WebcamRestartCtrl(
      $log,
      $modalInstance,
      $timeout,
      appAlert,
      photoManager,
    ) {
      const ctrl = this;
      ctrl.photoManager = photoManager;

      const handlePhotoManagerError = (err) => {
        const msg = findPhotoManagerErrorMessage(err);

        if (typeof msg === 'string') {
          $log.error(`Webcam error: ${msg}`);
          appAlert.error(`Webcam error: ${msg}`);
        } else {
          $log.error('Webcam error', msg);
          appAlert.error('Webcam error: unknown error');
        }
      };

      const handlePhotoManagerStart = () => {
        $timeout(() => {
          if (!photoManager.running()) {
            return;
          }

          photoManager.takeAssessmentPhotos();

          photoManager.takeWelcomePhoto().then(() => {
            if (!photoManager.running()) {
              return;
            }

            appAlert.clear();
            appAlert.success('Webcam ready');
            $modalInstance.dismiss();
          });
        }, CAMERA_WARMUP_MS);
      };

      ctrl.startPhotoManager = () => {
        photoManager
          .start()
          .then(handlePhotoManagerStart)
          .catch(handlePhotoManagerError);
      };
    },
  );
